'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _FormElement = require('./FormElement');

var _FormElement2 = _interopRequireDefault(_FormElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckboxGroup = function (_React$Component) {
  (0, _inherits3.default)(CheckboxGroup, _React$Component);

  function CheckboxGroup() {
    (0, _classCallCheck3.default)(this, CheckboxGroup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CheckboxGroup.__proto__ || (0, _getPrototypeOf2.default)(CheckboxGroup)).call(this));

    _this.onChange = _this.onChange.bind(_this);
    _this.renderControl = _this.renderControl.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(CheckboxGroup, [{
    key: 'onChange',
    value: function onChange(e) {
      var _this2 = this;

      if (this.props.onChange) {
        (function () {
          var values = [];
          _react2.default.Children.forEach(_this2.props.children, function (check, i) {
            var el = check.props.ref || _this2['check' + (i + 1)];
            var checkEl = el.querySelector('input[type=checkbox]');
            if (checkEl && checkEl.checked) {
              values.push(check.props.value);
            }
          });
          _this2.props.onChange(e, values);
        })();
      }
    }
  }, {
    key: 'renderControl',
    value: function renderControl(checkbox, i) {
      var _this3 = this;

      var props = { grouped: true };
      if (checkbox.props.ref) {
        props.ref = checkbox.props.ref;
      } else {
        props.checkboxRef = function (node) {
          return _this3['check' + (i + 1)] = node;
        };
      }
      if (this.props.name) {
        props.name = this.props.name;
      }
      return _react2.default.cloneElement(checkbox, props);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          label = _props.label,
          totalCols = _props.totalCols,
          cols = _props.cols,
          style = _props.style,
          required = _props.required,
          error = _props.error,
          children = _props.children,
          props = (0, _objectWithoutProperties3.default)(_props, ['className', 'label', 'totalCols', 'cols', 'style', 'required', 'error', 'children']);

      var grpClassNames = (0, _classnames2.default)(className, 'slds-form-element', {
        'slds-has-error': error,
        'slds-is-required': required
      }, typeof totalCols === 'number' ? 'slds-size--' + (cols || 1) + '-of-' + totalCols : null);
      var grpStyles = typeof totalCols === 'number' ? (0, _extends3.default)({ display: 'inline-block' }, style) : style;
      var errorMessage = error ? typeof error === 'string' ? error : (typeof error === 'undefined' ? 'undefined' : (0, _typeof3.default)(error)) === 'object' ? error.message : undefined : undefined;

      delete props.onChange;
      return _react2.default.createElement(
        'fieldset',
        (0, _extends3.default)({
          className: grpClassNames,
          style: grpStyles,
          onChange: this.onChange
        }, props),
        _react2.default.createElement(
          'legend',
          { className: 'slds-form-element__label slds-form-element__label--top' },
          label,
          required ? _react2.default.createElement(
            'abbr',
            { className: 'slds-required' },
            '*'
          ) : undefined
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'slds-form-element__control'
          },
          _react2.default.Children.map(children, this.renderControl),
          errorMessage ? _react2.default.createElement(
            'div',
            { className: 'slds-form-element__help' },
            errorMessage
          ) : undefined
        )
      );
    }
  }]);
  return CheckboxGroup;
}(_react2.default.Component);

exports.default = CheckboxGroup;


CheckboxGroup.propTypes = {
  className: _react.PropTypes.string,
  label: _react.PropTypes.string,
  required: _react.PropTypes.bool,
  error: _FormElement2.default.propTypes.error,
  name: _react.PropTypes.string,
  totalCols: _react.PropTypes.number,
  cols: _react.PropTypes.number,
  onChange: _react.PropTypes.func,
  children: _react.PropTypes.node,
  /* eslint-disable react/forbid-prop-types */
  style: _react.PropTypes.object
};

CheckboxGroup.isFormElement = true;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/react-lightning-design-system/lib/scripts/CheckboxGroup.js
// module id = 433
// module chunks = 0